/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightExchangePreparationRequest
 */
export interface FlightExchangePreparationRequest {
  /**
   *
   * @type {string}
   * @memberof FlightExchangePreparationRequest
   */
  requestId: string;
  /**
   *
   * @type {string}
   * @memberof FlightExchangePreparationRequest
   */
  selectionToken: string;
}

/**
 * Check if a given object implements the FlightExchangePreparationRequest interface.
 */
export function instanceOfFlightExchangePreparationRequest(
  value: object
): value is FlightExchangePreparationRequest {
  if (!("requestId" in value) || value["requestId"] === undefined) return false;
  if (!("selectionToken" in value) || value["selectionToken"] === undefined)
    return false;
  return true;
}

export function FlightExchangePreparationRequestFromJSON(
  json: any
): FlightExchangePreparationRequest {
  return FlightExchangePreparationRequestFromJSONTyped(json, false);
}

export function FlightExchangePreparationRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightExchangePreparationRequest {
  if (json == null) {
    return json;
  }
  return {
    requestId: json["request_id"],
    selectionToken: json["selection_token"],
  };
}

export function FlightExchangePreparationRequestToJSON(
  json: any
): FlightExchangePreparationRequest {
  return FlightExchangePreparationRequestToJSONTyped(json, false);
}

export function FlightExchangePreparationRequestToJSONTyped(
  value?: FlightExchangePreparationRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    request_id: value["requestId"],
    selection_token: value["selectionToken"],
  };
}
